export const agoraEndpoints = {
    keywords: {
        dictionary: {
            api: '/api/agora/keywords/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    groupTopics: {
        dictionary: {
            api: '/api/group-topics',
            method: 'GET',
            parameter: false
        }
    },
    catalogs: {
        vILTCatalogList: {
            api: '/api/agora/catalog/domain-specific/vilt/',
            method: 'GET',
            parameter: true
        },
        domain: {
            list: {
                api: '/api/agora/catalog/domain/list',
                method: 'GET',
                parameter: false
            }
        },
        list: {
            api: '/api/agora/catalog',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/catalog/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/catalog/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/catalog/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/catalog/delete',
            method: 'POST',
            parameter: false
        }
    },
    categories: {
        lmsCategory: {
            list: {
                api: '/api/agora/category/lms/list',
                method: 'GET',
                parameter: false
            },
            add: {
                api: '/api/agora/category/lms/add',
                method: 'POST',
                parameter: false
            }
        },
        list: {
            api: '/api/agora/category',
            method: 'GET',
            parameter: false
        },
        filteredList: {
            api: '/api/agora/category/list-filter',
            method: 'GET',
            parameter: false
        },
        categoriesInSameCatalog: {
            api: '/api/agora/category/list/same/catalog',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/category/details',
            method: 'GET',
            parameter: true
        },
        openDetails: {
            api: '/api/agora/category/open/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/category/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/category/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/category/delete',
            method: 'POST',
            parameter: false
        },
        byTopicId: {
            api: '/api/agora/category/dictionary/bytopic',
            method: 'GET',
            parameter: true
        }
    },
    products: {
        producVariantMapping: {
            api: '/api/agora/productvariant/mapping',
            method: 'GET',
            parameter: true
        },
        listByGroup: {
            api: '/api/agora/product/group',
            method: 'GET',
            parameter: true
        },
        listByGroupEvaluationAvailable: {
            api: '/api/product/evaluation/available/group',
            method: 'GET',
            parameter: true
        },
        list: {
            api: '/api/agora/product',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/product/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/product/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/product/edit',
            method: 'POST',
            parameter: false
        },
        bulkEdit: {
            api: '/api/agora/product/bulk-edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/product/delete',
            method: 'POST',
            parameter: false
        },
        listBySkuOrName: {
            api: '/api/agora/product/list-filtered',
            method: 'GET',
            parameter: true
        },
        detailsBySKU: {
            api: '/api/agora/product/details/sku',
            method: 'GET',
            parameter: true
        }
    },
    productVariants: {
        list: {
            api: '/api/agora/productvariant',
            method: 'GET',
            parameter: false
        },
        listByProductSKU: {
            api: '/api/agora/productvariant/list/product-sku',
            method: 'GET',
            parameter: true
        },
        listByRequireVoucher: {
            api: '/api/agora/productvariant/list/voucher/required/dictionary',
            method: 'GET',
            parameter: true
        },
        readBySKU: {
            api: '/api/agora/productvariant/sku',
            method: 'GET',
            parameter: true
        },
        details: {
            api: '/api/agora/productvariant/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/productvariant/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/productvariant/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/productvariant/delete',
            method: 'POST',
            parameter: false
        },
        manufacturer: {
            api: '/api/agora/productvariant/manufacturer',
            method: 'GET',
            parameter: true
        },
        unavailable: {
            api: '/api/agora/productvariant/list/unavailable',
            method: 'GET',
            parameter: false
        },
        bulkEdit: {
            api: '/api/agora/productvariant/bulk-edit',
            method: 'POST',
            parameter: false
        },
        getProductContentDeliverablesBySku: '/api/library/productcontent/deliverables/sku',
        examFulfillmentType: {
            api: '/api/agora/productvariant/fulfillment-types',
            method: 'GET',
            parameter: false
        },
        editExamFulfillmentType: {
            api: '/api/agora/productvariant/fulfillment-details/update',
            method: 'POST',
            parameter: false
        },
        customFulfillmentPolicies: {
            add: {
                api: '/api/agora/custom-fulfillment-policy/add',
                method: 'POST',
                parameter: false
            },
            list: {
                api: '/api/agora/custom-fulfillment-policy/',
                method: 'GET',
                parameter: false
            }
        },
        updateExternalSKU: {
            api: '/api/agora/productvariant/externalSKU/update/',
            method: 'POST',
            parameter: true,
        }
    },
    productGroups: {
        list: {
            api: '/api/agora/productgroup',
            method: 'GET',
            parameter: false
        },
        sortedList: {
            api: '/api/agora/productgroup/domain/list',
            method: 'GET',
            parameter: false
        },
        filteredList: {
            api: '/api/agora/productgroup/list-filters',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/productgroup/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/productgroup/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/productgroup/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/productgroup/delete',
            method: 'POST',
            parameter: false
        },
        digital: {
            api: '/api/agora/productgroup/digital',
            method: 'GET',
            parameter: false
        },
        dictionaryPerDomain: {
            api: '/api/agora/productgroup/dictionary-per-domain',
            method: 'GET',
            parameter: false
        }
    },
    topics: {
        inCategories: {
            api: '/api/agora/topics/inCategories',
            method: 'GET',
            parameter: false
        },
        inCategoryTopics: {
            api: '/api/agora/topics/inCategories/category',
            method: 'GET',
            parameter: true
        },
        listTopics: {
            api: '/api/agora/topics/listTopics',
            method: 'GET',
            parameter: false
        },
        list: {
            api: '/api/agora/topics/list',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/topics/add-topic-subtopic',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/topics/edit-topic-subtopic',
            method: 'POST',
            parameter: false
        },
        deleteTopic: {
            api: '/api/agora/topics/delete-topic',
            method: 'POST',
            parameter: false
        },
        listAvailableSubtopics: {
            api: '/api/agora/topics/subtopics-available-list',
            method: 'GET',
            parameter: false
        },
        assign: {
            api: '/api/agora/topics/assign-topic-subtopic',
            method: 'POST',
            parameter: false
        },
        uploadSvgIcon: {
            api: '/api/agora/topics/update/svg',
            method: 'POST',
            parameter: true
        }
    },
    customTopics: {
        list: {
            api: '/api/agora/custom/topics',
            method: 'GET',
            parameter: false
        },
        dictionary: {
            api: '/api/agora/custom/topics/root/list',
            method: 'GET',
            parameter: false
        },
        dictionaryIdTitle: {
            api: '/api/agora/custom/topics/root/listIdTitle',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/custom/topics/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/custom/topics/edit',
            method: 'POST',
            parameter: false
        },
        listAvailableSubtopics: {
            api: '/api/agora/custom/topics/list/subtopics',
            method: 'GET',
            parameter: true
        },
        nestedList: {
            api: '/api/agora/custom/topics/nested/list',
            method: 'GET',
            parameter: false
        },
        categoryListByTopicCode: {
            api: '/api/agora/category/list/custom-topic',
            method: 'GET',
            parameter: true
        },
        categoryDictionary: {
            api: '/api/agora/category/domain/dictionary',
            method: 'GET',
            parameter: true
        }
    },
    brands: {
        list: {
            api: '/api/agora/brands/list',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/brands/details',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/brands/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/brands/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/brands/delete',
            method: 'POST',
            parameter: false
        }
    },
    productSegments: {
        list: {
            api: '/api/agora/product-segment',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/product-segment/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/product-segment/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/product-segment/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/product-segment/delete',
            method: 'POST',
            parameter: false
        }
    },
    accounts: {
        consumption: {
            read: {
                api: '/api/agora/account/catalogproperties',
                method: 'GET',
                parameter: false
            }
        },
        list: {
            api: '/api/agora/account',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/account/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/account/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/account/edit',
            method: 'POST',
            parameter: false
        },
        invite: {
            api: '/api/agora/account/invite',
            method: 'POST',
            parameter: false
        },
        adminEdit: {
            api: '/api/agora/adm/account/edit',
            method: 'POST',
            parameter: false
        },
        editSegments: {
            api: '/api/agora/account/edit/segments',
            method: 'POST',
            parameter: false
        },
        editLxpConfig: {
            api: '/api/agora/account/lxp/add',
            method: 'POST',
            parameter: true
        },
        editAddresses: {
            api: '/api/agora/account/edit/address',
            method: 'POST',
            parameter: false
        },
        editSmtp: {
            api: '/api/agora/account/smtp/edit',
            method: 'POST',
            parameter: true
        },
        testAgnosticSmtp: {
            api: '/api/agora/account/smtp/agnostic/test',
            method: 'POST',
            parameter: true
        },
        delete: {
            api: '/api/agora/account/delete',
            method: 'POST',
            parameter: false
        },
        editSignatories: {
            api: '/api/agora/account/certificate-signatories/edit',
            method: 'POST',
            parameter: false
        },
        editSellerAccount: {
            api: '/api/agora/account/admin/sellerinfo/edit',
            method: 'POST',
            parameter: false
        },
        domain: {
            api: '/api/agora/account/domain',
            method: 'GET',
            parameter: true
        },
        dictionary: {
            api: '/api/agora/account/dictionary',
            method: 'GET',
            parameter: false
        },
        dictionaryOnlyBuyers: {
            api: '/api/agora/account/buyer/internal/dictionary',
            method: 'GET',
            parameter: false
        },
        checkifEmailExists: {
            api: '/api/agora/account/check/email',
            method: 'GET',
            parameter: true
        },
        checkPanNumber: {
            api: '/api/agora/account/check/pan-number',
            method: 'GET',
            parameter: true
        },
        checkGstNumber: {
            api: '/api/agora/account/check/gst-number',
            method: 'GET',
            parameter: true
        },
        editFinance: {
            api: '/api/agora/account/finance/edit',
            method: 'POST',
            parameter: false
        },
        editCatalog: {
            api: '/api/agora/catalogproperties/edit',
            method: 'POST',
            parameter: false
        },
        levelPolicies: {
            api: '/api/debtor/policy/level/dictionary',
            method: 'GET',
            parameter: true
        },
        actionPolicies: {
            api: '/api/debtor/policy/action/dictionary',
            method: 'GET',
            parameter: true
        },
        creditDetails: {
            api: '/api/buyer/credit',
            method: 'GET',
            parameter: true
        },
        addCreditCardSegment: {
            api: '/api/agora/account/cc/segment',
            method: 'POST',
            parameter: true
        },
        listByReferrer: {
            api: '/api/agora/account/list/byreferrer',
            method: 'GET',
            parameter: false
        },
        listContractedBuyerSegments: {
            api: '/api/agora/contracted-buyer-segments',
            method: 'GET',
            parameter: false
        },
        getAccountNameByDomain: {
            api: '/api/agora/readAccountNameByDomain',
            method: 'POST',
            parameter: false
        },
        createAccountAccreditationType: {
            api: '/api/agora/contracted-buyer-segment/create',
            method: 'POST',
            parameter: false
        }
    },
    domainConfigurations: {
        list: {
            api: '/api/agora/domain-configuration/list',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/domain-configuration/admin/create',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/domain-configuration/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/domain-configuration/delete',
            method: 'POST',
            parameter: false
        },
        getGroupTypesDict: {
            api: '/api/agora/configuration/dictionary/account-configuration-group-type',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/agora/domain-configuration/details',
            method: 'GET',
            parameter: false
        },
        domain: {
            api: '/api/agora/domain/dictionary',
            method: 'GET',
            parameter: false
        },
    },
    sellerInvitations: {
        list: {
            api: '/api/agora/seller-invitation',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/seller-invitation/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/seller-invitation/add',
            method: 'POST',
            parameter: false
        },
        listSellerInvitations: {
            api: '/api/agora/seller-invitation/supplier/list',
            method: 'GET',
            parameter: true
        },
        send: {
            api: '/api/agora/seller-invitation/supplier/bulk-send',
            method: 'POST',
            parameter: false
        }
    },
    bankingData: {
        list: {
            api: '/api/agora/banking-data',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/banking-data/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/banking-data/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/banking-data/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/banking-data/delete',
            method: 'POST',
            parameter: false
        }
    },
    taxData: {
        list: {
            api: '/api/agora/tax-data',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/tax-data/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/tax-data/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/tax-data/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/tax-data/delete',
            method: 'POST',
            parameter: false
        }
    },
    employees: {
        list: {
            api: '/api/agora/employee',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/employee/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/employee/add',
            method: 'POST',
            parameter: false
        },
        adminAdd: {
            api: '/api/agora/adm/employee/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/employee/edit',
            method: 'POST',
            parameter: false
        },
        activate: {
            api: '/api/agora/employee/activate',
            method: 'POST',
            parameter: false
        },
        deactivate: {
            api: '/api/agora/employee/deactivate',
            method: 'POST',
            parameter: false
        },
        invite: {
            api: '/api/agora/employee/invite',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/employee/delete',
            method: 'POST',
            parameter: false
        },
        signatoryListAdm: {
            api: '/api/agora/adm/employee/signatory/list',
            method: 'GET',
            parameter: true
        },
        signatoryListJWT: {
            api: '/api/agora/employee/signatory/list',
            method: 'GET',
            parameter: false
        },
        authorizedSignatoryListJWT: {
            api: '/api/agora/employee/authorized/signatories/list',
            method: 'GET',
            parameter: false
        },
        trainingManagerDictionary: {
            api: '/api/agora/employee/training/managers/dictionary',
            method: 'GET',
            parameter: true
        },
        trainingManagerList: {
            api: '/api/agora/employee/training/managers/list',
            method: 'GET',
            parameter: true
        },
        getByEmail: {
            api: '/api/agora/employee/email',
            method: 'GET',
            parameter: false
        },
        updatePrivatePolicy: {
            api: '/api/agora/privacy-acceptance/update',
            method: 'POST',
            parameter: false
        },
        getPrivacyAcceptanceState: {
            api: '/api/agora/privacy-acceptance',
            method: 'POST',
            parameter: false
        },
        broadcast: {
            api: '/api/agora/employee/broadcast',
            method: 'POST',
            parameter: true
        },
        promoteToInstructor: {
            api: '/api/agora/employee/promote/instructor',
            method: 'POST',
            parameter: false
        },
        informSellerAboutConversation: {
            api: '/api/agora/employee/seller/admin/create/conversation/domain/',
            method: 'POST',
            parameter: true
        },
        informAboutMessage: {
            api: '/api/agora/employee/create/message/conversation/',
            method: 'POST',
            parameter: true
        }
    },
    communication: {
        list: {
            api: '/api/agora/communication',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/communication/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/communication/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/communication/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/communication/delete',
            method: 'POST',
            parameter: false
        }
    },
    configuration: {
        list: {
            api: '/api/agora/configuration',
            method: 'GET',
            parameter: false
        },
        details: {
            api: '/api/agora/configuration/details',
            method: 'GET',
            parameter: true
        },
        add: {
            api: '/api/agora/configuration/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/configuration/edit',
            method: 'POST',
            parameter: false
        },
        delete: {
            api: '/api/agora/configuration/delete',
            method: 'POST',
            parameter: false
        }
    },
    dictionary: {
        topic: {
            byCatalog: {
                api: '/api/agora/topics/dictionary/inCategories',
                method: 'GET',
                parameter: false
            }
        },
        smtpTypes: {
            api: '/api/agora/configuration/dictionary/smtp-type',
            method: 'GET',
            parameter: false
        },
        configurationType: {
            api: '/api/agora/configuration/dictionary/types',
            method: 'GET',
            parameter: false
        },
        currency: {
            api: '/api/agora/configuration/dictionary/currency',
            method: 'GET',
            parameter: false
        },
        currencyList: {
            api: '/api/agora/configuration/list/by/currency',
            method: 'GET',
            parameter: false
        },
        currencyDummy: {
            api: '/api/dummy/agora/configuration/dictionary/currency',
            method: 'GET',
            parameter: false
        },
        consolidationOrdersFrequency: {
            api: '/api/agora/configuration/list/by/account-consolidation-orders-frequency-type',
            method: 'GET',
            parameter: false
        },
        language: {
            api: '/api/agora/configuration/dictionary/language-type',
            method: 'GET',
            parameter: false
        },
        popularLanguages: {
            api: '/api/agora/configuration/dictionary/popular-languages',
            method: 'GET',
            parameter: false
        },
        otherLanguages: {
            api: '/api/agora/configuration/dictionary/other-languages',
            method: 'GET',
            parameter: false
        },
        organizationType: {
            api: '/api/agora/configuration/dictionary/account-type',
            method: 'GET',
            parameter: false
        },
        productType: {
            api: '/api/agora/configuration/dictionary/p-type',
            method: 'GET',
            parameter: false
        },
        seller: {
            api: '/api/agora/account/seller/dictionary',
            method: 'GET',
            parameter: false
        },
        productAccessDuration: {
            api: '/api/agora/configuration/dictionary/p-access-duration',
            method: 'GET',
            parameter: false
        },
        address: {
            api: '/api/agora/address/dictionary',
            method: 'GET',
            parameter: false
        },
        taxData: {
            api: '/api/agora/tax-data/dictionary',
            method: 'GET',
            parameter: false
        },
        bankData: {
            api: '/api/agora/banking-data/dictionary',
            method: 'GET',
            parameter: false
        },
        department: {
            api: '/api/agora/configuration/dictionary/department-type',
            method: 'GET',
            parameter: false
        },
        taxNumber: {
            api: '/api/agora/configuration/dictionary/tax-number-type',
            method: 'GET',
            parameter: false
        },
        phoneNumberType: {
            api: '/api/agora/configuration/dictionary/phone-number-type',
            method: 'GET',
            parameter: false
        },
        role: {
            api: '/api/agora/configuration/dictionary/user-role-type',
            method: 'GET',
            parameter: false
        },
        classificationLevel: {
            api: '/api/agora/configuration/dictionary/classification-level-type',
            method: 'GET',
            parameter: false
        },
        calendar: {
            api: '/api/agora/configuration/dictionary/calendar-configuration-type',
            method: 'GET',
            parameter: false
        },
        accountSegments: {
            api: '/api/agora/configuration/dictionary/account-segments-type',
            method: 'GET',
            parameter: false
        },
        accountAccreditations: {
            api: '/api/agora/configuration/dictionary/account-accreditations-type',
            method: 'GET',
            parameter: false
        },
        sellerManagedSegmentsTypeBySeller: {
            api: '/api/agora/configuration/list/seller-managed-segments-type',
            method: 'GET',
            parameter: false
        },
        accountAccreditationsProducts: {
            api: '/api/agora/list/account-accreditation-type',
            method: 'GET',
            parameter: false
        },
        accountComputedSegments: {
            api: '/api/agora/configuration/dictionary/computed-account-segments-type',
            method: 'GET',
            parameter: false
        },
        deliveryFormat: {
            api: '/api/agora/configuration/dictionary/p-delivery-type',
            method: 'GET',
            parameter: false
        },
        certyficateType: {
            api: '/api/agora/configuration/dictionary/p-cert-type',
            method: 'GET',
            parameter: false
        },
        examFulfillmentType: {
            api: '/api/agora/configuration/dictionary/p-exam-fulfillment-type',
            method: 'GET',
            parameter: false
        },
        taxClass: {
            api: '/api/agora/configuration/dictionary/p-tax-class',
            method: 'GET',
            parameter: false
        },
        associatedCompany: {
            api: '/api/agora/configuration/dictionary/company-assoc',
            method: 'GET',
            parameter: false
        },
        salesOrganization: {
            api: '/api/agora/configuration/dictionary/salesorg',
            method: 'GET',
            parameter: false
        },
        paymentTerm: {
            api: '/api/agora/configuration/dictionary/paymentterms',
            method: 'GET',
            parameter: false
        },
        statusCredit: {
            api: '/api/agora/configuration/dictionary/credit-application-status-type',
            method: 'GET',
            parameter: false
        },
        decisionCredit: {
            api: '/api/agora/configuration/dictionary/credit-application-decision-type',
            method: 'GET',
            parameter: false
        },
        productId: {
            api: '/api/agora/configuration/dictionary/p-id',
            method: 'GET',
            parameter: false
        },
        sellerSegments: {
            api: '/api/agora/configuration/dictionary/seller-managed-segments-type',
            method: 'GET',
            parameter: false
        },
        domain: {
            api: '/api/agora/domain/dictionary',
            method: 'GET',
            parameter: false
        },
        category: {
            api: '/api/agora/category/dictionary',
            method: 'GET',
            parameter: false
        },
        catalog: {
            byCode: {
                api: '/api/agora/catalog/dictionary/by/code',
                method: 'GET',
                parameter: false
            },
            api: '/api/agora/catalog/dictionary',
            method: 'GET',
            parameter: false
        },
        product: {
            api: '/api/agora/product/dictionary',
            method: 'GET',
            parameter: false
        },
        productByType: {
            api: '/api/agora/productbytype/dictionary',
            method: 'GET',
            parameter: true
        },
        productGroup: {
            api: '/api/agora/productgroup/dictionary',
            method: 'GET',
            parameter: false
        },
        productGroupByDomain: {
            api: '/api/agora/productgroupbydomain/dictionary',
            method: 'GET',
            parameter: false
        },
        productSegment: {
            api: '/api/agora/product-segment/dictionary',
            method: 'GET',
            parameter: false
        },
        country: {
            api: '/api/agora/country/dictionary',
            method: 'GET',
            parameter: false
        },
        patternList: {
            api: '/api/agora/countryCode/dictionary',
            method: 'GET',
            parameter: false
        },
        productCategoryFamily: {
            api: '/api/agora/configuration/dictionary/p-category-family',
            method: 'GET',
            parameter: false
        },
        productDomain: {
            api: '/api/agora/configuration/dictionary/p-domain',
            method: 'GET',
            parameter: false
        },
        productFreightClassId: {
            api: '/api/agora/configuration/dictionary/p-freight-class-id',
            method: 'GET',
            parameter: false
        },
        productLevel: {
            api: '/api/agora/configuration/dictionary/p-level',
            method: 'GET',
            parameter: false
        },
        productDiscountCategory: {
            api: '/api/agora/configuration/dictionary/p-discount-category',
            method: 'GET',
            parameter: false
        },
        productCertificateType: {
            api: '/api/agora/configuration/dictionary/p-cert-type',
            method: 'GET',
            parameter: false
        },
        productFulfillmentType: {
            api: '/api/agora/configuration/dictionary/p-exam-fulfillment-type',
            method: 'GET',
            parameter: false
        },
        productLanguage: {
            api: '/api/agora/configuration/dictionary/p-lang',
            method: 'GET',
            parameter: false
        },
        accountType: {
            api: '/api/agora/configuration/dictionary/account-type',
            method: 'GET',
            parameter: false
        },
        companyHoldingType: {
            api: '/api/agora/configuration/dictionary/company-holding-type',
            method: 'GET',
            parameter: false
        },
        companyRegistrationType: {
            api: '/api/agora/configuration/dictionary/company-registration-type',
            method: 'GET',
            parameter: false
        },
        accountDeterminationGroup: {
            api: '/api/product/variant/accountdetermination',
            method: 'GET',
            parameter: false
        },
        employeeRoles: {
            api: '/api/agora/configuration/user-roles/list',
            method: 'GET',
            parameter: false
        },
        brands: {
            api: '/api/agora/configuration/dictionary/brand',
            method: 'GET',
            parameter: false
        },
        sellerRegions: {
            api: '/api/agora/configuration/dictionary/seller-region',
            method: 'GET',
            parameter: false
        },
        accountTypes: {
            api: '/api/agora/configuration/dictionary/computed-account-type',
            method: 'GET',
            parameter: false
        },
        priceListType: {
            api: '/api/agora/configuration/dictionary/price-list-type',
            method: 'GET',
            parameter: false
        },
        domainList: {
            api: '/api/agora/domain/dictionary',
            method: 'GET',
            parameter: false
        },
        domainListBuyer: {
            api: '/api/agora/account/buyer/domains/dictionary',
            method: 'GET',
            parameter: false
        },
        domainListSeller: {
            api: '/api/agora/account/seller/domains/dictionary',
            method: 'GET',
            parameter: false
        },
        buyerAccountList: {
            api: '/api/agora/account/buyer/dictionary',
            method: 'GET',
            parameter: false
        },
        customCatalogListByPublisher: {
            api: '/api/agora/catalog/domain-specific/publisher/list',
            method: 'GET',
            parameter: false
        },
        getCourseSegment: {
            api: '/api/agora/productsegment/dictionary/domain',
            method: 'GET',
            parameter: true
        },
        getCustomAttributesFormat: {
            api: '/api/agora/configuration/dictionary/custom-attribute-format',
            method: 'GET',
            parameter: false
        },
        getCustomAttributesType: {
            api: '/api/agora/configuration/dictionary/target-entity',
            method: 'GET',
            parameter: false
        },
        bundle:{
            api: '/api/agora/bundle/dictionary',
            method: 'GET',
            parameter: false
        }
    },
    credit: {
        list: {
            api: '/api/agora/credit',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/credit',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/credit/edit',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/agora/credit/details',
            method: 'GET',
            parameter: true
        },
        approve: {
            api: '/api/agora/credit/approve',
            method: 'POST',
            parameter: false
        },
        reject: {
            api: '/api/agora/credit/reject',
            method: 'POST',
            parameter: false
        },
        remove: {
            api: '/api/agora/credit/remove',
            method: 'POST',
            parameter: false
        },
        buyerEmails: {
            api: '/api/agora/credit/listemails',
            method: 'GET',
            parameter: true
        }
    },
    public: {
        userRoleType: {
            api: '/api/agora/public/list/user-role-type',
            method: 'GET',
            parameter: false
        },
        accountType: {
            api: '/api/agora/public/list/account-type',
            method: 'GET',
            parameter: false
        },
        companyHoldingType: {
            api: '/api/agora/public/list/company-holding-type',
            method: 'GET',
            parameter: false
        },
        companyRegistrationType: {
            api: '/api/agora/public/list/company-registration-type',
            method: 'GET',
            parameter: false
        }
    },
    report: {
        details: {
            api: '/api/agora/report/details',
            method: 'GET',
            parameter: true
        }
    },
    evaluationVouchers: {
        add: {
            api: '/api/agora/evaluation-vouchers/add',
            method: 'POST',
            parameter: false
        }
    },
    surcharges: {
        configurationListBy: {
            api: '/api/agora/configuration/list/by',
            method: 'GET',
            parameter: true
        },
        dictionaryByType: {
            api: '/api/agora/surcharge/virtual-dictionary',
            method: 'GET',
            parameter: true
        },
        schema: {
            api: '/api/agora/surcharge/schema',
            method: 'GET',
            parameter: false
        },
        list: {
            api: '/api/agora/surcharge',
            method: 'GET',
            parameter: false
        },
        add: {
            api: '/api/agora/surcharge/add',
            method: 'POST',
            parameter: false
        },
        edit: {
            api: '/api/agora/surcharge/edit',
            method: 'POST',
            parameter: false
        },
        details: {
            api: '/api/agora/surcharge/details',
            method: 'GET',
            parameter: false
        },
        delete: {
            api: '/api/agora/surcharge/delete',
            method: 'POST',
            parameter: false
        }
    },
    priceList: {
        fetchPriceList: {
            api: '/api/agora/pricelist/list',
            method: 'GET',
            parameter: false
        },
        fetchPriceListItemDetails: {
            api: '/api/agora/priceList/details',
            method: 'GET',
            parameter: false
        },
        fetchPrices: {
            api: '/api/agora/priceList/product/list',
            method: 'GET',
            parameter: false
        },
        savePriceList: {
            api: '/api/agora/priceList/add',
            method: 'POST',
            parameter: false
        },
        updatePriceList: {
            api: '/api/agora/priceList/edit',
            method: 'POST',
            parameter: false
        },
        deletePriceList: {
            api: '/api/agora/priceList/delete/',
            method: 'POST',
            parameter: false
        },
        fetchProductBySKU: {
            api: '/api/agora/priceList/product/detail',
            method: 'GET',
            parameter: false
        },
        createProductForPrice: {
            api: '/api/agora/priceList/product/add',
            method: 'POST',
            parameter: false
        },
        editProductForPrice: {
            api: '/api/agora/priceList/pricing/edit',
            method: 'POST',
            parameter: false
        },
        deleteProductPrice: {
            api: '/api/agora/priceList/pricing/delete',
            method: 'POST',
            parameter: false
        },
        searchSellerById: {
            api: '/api/agora/account/buyer/simple',
            method: 'GET',
            parameter: false
        }
    },
    lxpConfiguration: {
        fetchProductsList: {
            api: '/api/agora/lxp-configuration/products/list',
            method: 'GET',
            parameter: false
        },
        fetchPublishedProductsList: {
            api: '/api/agora/lxp-product/list-all',
            method: 'GET',
            parameter: false
        },
        publishedToLXP: {
            api: '/api/agora/lxp-product/publish',
            method: 'POST',
            parameter: false
        },
        fetchSellers: {
            api: '/api/agora/account/seller/accountid/dictionary',
            method: 'GET',
            parameter: false
        },
        fetchChannels: {
            api: '/api/agora/lxp-product/channels',
            method: 'GET',
            parameter: false
        },
        fetchGroups: {
            api: '/api/agora/lxp-product/groups',
            method: 'GET',
            parameter: false
        },
        updateLXPProduct: {
            api: '/api/agora/lxp-product/update',
            method: 'POST',
            parameter: false
        },
        pricingDetails: {
            api: '/api/agora/lxp-product/pricing/details',
            method: 'GET',
            parameter: false
        },
        fetchTransactionTypes: {
            api: '/api/agora/configuration/dict/filtered/transaction-type',
            method: 'GET',
            parameter: false
        }
    },
    permissions: {
        list: {
            api: '/api/agora/permissions/list',
            method: 'GET',
            parameter: false
        },
        edit: {
            api: '/api/agora/permissions/edit',
            method: 'POST',
            parameter: true
        },
        add: {
            api: '/api/agora/permissions/add',
            method: 'POST',
            parameter: true
        },
    },
    lxpInstanceSetup: {
        getCurrentInstance: {
            api: '/api/agora/lxp-integration/instance',
            method: 'GET',
            parameter: false
        },
        updateCurrentInstance: {
            api: '/api/agora/lxp-integration/update-instance',
            method: 'POST',
            parameter: false
        },
        testLXPInstance: {
            api: '/api/agora/lxp-integration/test-instance',
            method: 'POST',
            parameter: false
        }
    },
    approvals: {
        fetchApprovedRules: {
            api: '/api/agora/buyer-approvals/approvalpolicy/list',
            method: 'GET',
            parameter: false
        },
        addApprovedRules: {
            api: '/api/agora/buyer-approvals/approvalpolicy/add',
            method: 'POST',
            parameter: false
        },
        editApprovedRules: {
            api: '/api/agora/buyer-approvals/approvalpolicy/edit',
            method: 'POST',
            parameter: false
        },
        deleteApprovedRules: {
            api: '/api/agora/buyer-approvals/approvalpolicy/delete',
            method: 'POST',
            parameter: false
        },
        fetchUsersForApprovalGroup: {
            api: '/api/agora/employee/list-all',
            method: 'GET',
            parameter: false
        },
        saveUsersForApprovalGroup: {
            api: '/api/agora/approvalGroup/add',
            method: 'POST',
            parameter: false
        },
        editUsersForApprovalGroup: {
            api: '/api/agora/buyer-approvals/approvalGroup/edit',
            method: 'POST',
            parameter: false
        },
        fetchApprovalGroups: {
            api: '/api/agora/buyer-approvals/approvalGroup',
            method: 'GET',
            parameter: false
        },
        fetchRuleOperatorTypes: {
            api: '/api/agora/configuration/dictionary/approval-rule-operator-type',
            method: 'GET',
            parameter: false
        },
        fetchRuleType: {
            api: '/api/agora/configuration/dict/filtered/approval-rule-type',
            method: 'GET',
            parameter: false
        },
        fetchCurrencyForBuyer: {
            api: '/api/agora/account/currency',
            method: 'GET',
            parameter: false
        },
        deleteAprrovalRule: {
            api: '/api/agora/account/currency',
            method: 'GET',
            parameter: false
        },
        fetchConsumptionApprovalRequestsByStatusAndType: {
            api: '/api/agora/approval-request/list-by-status-and-type',
            method: 'GET',
            parameter: false,
        },
        approveConsumptionRequest: {
            api: '/api/agora/approval-request/consumption-request-approve',
            method: 'POST',
            parameter: false,
        },
        rejectConsumptionRequest: {
            api: '/api/agora/approval-request/consumption-request-reject',
            method: 'POST',
            parameter: false,
        }
    },
    bundle:{
        details:{
            api:'/api/agora/bundle/details',
            method: 'GET',
            parameter: true
        },
        detailsBySku:{
            api:'/api/agora/license-pricing/read/by-sku',
            method: 'GET',
            parameter: true
        }
    }
};



// WEBPACK FOOTER //
// ./src/endpoints/agora.endpoints.ts